module.exports = __webpack_public_path__ + "img/hk.876c73bb.png";